import AllhomesListingBadges from './allhomes-listing-badges';
import AllhomesListingBadgesGraphQL from './allhomes-listing-badges-graphql';
export { AllhomesListingBadges };
export default AllhomesListingBadgesGraphQL;